import script from "./order.vue?vue&type=script&setup=true&lang=ts"
export * from "./order.vue?vue&type=script&setup=true&lang=ts"

import "./order.vue?vue&type=style&index=0&id=685f837c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685f837c"]])

export default __exports__